import React from 'react';
import FormEditor from '../form-editor/FormEditor';
import { Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { environment, testUrl } from '../../api/api_urls';
import { apiPostPut } from '../../api/api_methods';
import { ADMIN_ENDPOINTS } from '../../api/api_endpoints';

function Blogs2() {
  const navigate = useNavigate();

  const topics = [
    'Resume',
    'CoverLetter Tips',
    'Interview Preparation',
    'Skill Development',
    'Certifications',
    'Role of AI',
    'Smart Job Search',
    'Automation in Recruitment',
    'Syllabus Breakdown',
    'Study Plans',
    'Time Management',
    'Previous Year Papers',
    'Mock Tests',
    'Emerging Tech',
    'Job Market Trends',
    'Programming Languages to Learn',
    'Remote Work',
    'Freelancing in Tech',
    'Soft Skills for Career Success',
    'Productivity',
    'Work-Life Balance',
    'Leadership',
    'Management',
    'New Features in Your Job Portal',
    'How AI Helps Job Seekers',
    'Personalized Job Recommendations',
  ];

  const createNewBlog = async () => {
    const newBlog = {
      title:
        "REAIDY.IO Secures Microsoft Founder's Hub Technical Grant!(5K+ 40k worth Premium tools)",
      featuredImage: 'https://www.reaidy.io/assets/img/th-1/blog51.png',
      category: 'Technology',
      description: 'New Blog Description',
      htmlContent: '<p>New Blog Content</p>',
      author: {
        name: 'Founders Hub',
      },
    };

    try {
      const response = await apiPostPut(newBlog, ADMIN_ENDPOINTS.BLOGS_CREATE, 'POST');

      if (response.status === 200) {
        console.log('Blog created successfully:', response.body);
        navigate(`/${environment}/dashboards/blogs2`);
      } else {
        console.error('Failed to create blog');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleSelect = (e) => {
    console.log(e.target.value);
  };

  return (
    <div className="d-flex align-items-center justify-content-between w-100">
      <form onSubmit={createNewBlog} required>
        <div className="form-group">
          <label htmlFor="jobTitle">Blogs Title</label>
          <input
            type="text"
            className="form-control mt-6"
            id="jobTitle"
            placeholder="Enter blogs Title"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="Image">Featured Image</label>
          <input
            type="file"
            className="form-control mt-2"
            id="Image"
            placeholder="Choose Your Image"
            accept="image/*"
            required
          />
        </div>
        {/* <div>
          <label htmlFor="Content">Content</label>
          <input type="text" className='form-control mt-2' id='Content' placeholder='Enter Image URL' required/>
        </div> */}
        <div className="form-group">
          <label htmlFor="topicSelect">Category</label>
          <select className="form-control mt-2" id="topicSelect" required onChange={handleSelect}>
            {topics.map((topic, index) => (
              <option key={index} value={topic}>
                {topic}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label htmlFor="AuthorName">Author</label>
          <input
            type="text"
            className="form-control mt-2"
            id="AuthorName"
            placeholder="Enter AuthorName "
            required
          />
        </div>
        {/* <div>
          <label htmlFor="htmlContent">Html Content</label>
          <input type="text" className='form-control mt-2' id='htmlContent' placeholder='Enter Html Content ' required/>
        </div> */}
        <div className="form-group">
          <label htmlFor="jobDescription">Blogs Description</label>
          <textarea
            className="form-control mt-2"
            id="jobDescription"
            placeholder="Enter blogs Description"
            required
          ></textarea>
        </div>
        <FormEditor required />
        <div className=" mt-3 ">
          <Button
            type="submit"
            className="btn "
            style={{ border: '1px solid #fb9678', color: '#fb9678' }}
          >
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
}

export default Blogs2;
